import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import Cookies from 'js-cookie';
import { Post } from 'Xhr/Xhr';
import { env } from 'env';

export const GetReceptions = async (
  idTestimontial,
  setReceptions
) => {
  const user = JSON.parse(Cookies.get('user'));
  setReceptions(0);
  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_FISH_HAYE_PARDAKHT_LIST}`,
    true,
    {
      idPatient: user?.IdPatient,
      idType: 7,
      idTestimontial,
    }
  ).then((response) => {
    if (response.data.Data.ListFileArchive.length === 0) {
      SwalAlert(
        'info',
        'داده ای موجود نیست',
        false,
        null,
        null,
        null,
        null,
        true
      );
    }
    const res = response.data.Data.ListFileArchive.map(
      (file) => {
        if (
          ['.jpg', '.png', '.tiff', '.webp']?.includes(
            file.NameFile?.match(/\.[0-9a-z]+$/i)[0]
          )
        ) {
          file.base64Extention =
            file.base64Extention = `data:image/${file.NameFile.match(
              /\.[0-9a-z]+$/i
            )[0]
              .split('.')
              .pop()
              .toLowerCase()};base64,`;

          return file;
        } else {
          return file;
        }
      }
    );

    if (response.data.resCode === 1) {
      setReceptions(res);
    } else {
      SwalAlert('error', response.data.resMessage, false);
      setReceptions();
    }
  });
};
